import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from '../selectors.js/user.selectors';
import { getCurrentUserWorkTimeSaldoInformation } from '../services/getCurrentUserWorkTimeSaldoInformation.service';

export const loadCurrentUserWorkTimeSaldoInformation = createAsyncThunk(
  'user/loadCurrentUserWorkTimeSaldoInformation',
  async (_, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const response =
      await getCurrentUserWorkTimeSaldoInformation(activeEmployerInfo);

    return response;
  }
);
